import React from "react";
import { Box, Divider, Stack, Typography } from "@mui/material";

import desiredPromptsImage from "src/shared/assets/desiredPrompts.png";
import desiredPromptsGif from "src/shared/assets/gifSections/desiredPrompts.gif";

export const DesiredPrompts: React.FC = () => {
  return (
    <Stack width={1} direction="column" gap={1}>
      <Stack
        width={1}
        direction="column"
        justifyContent="center"
        alignItems="center"
        gap={1}
      >
        <Typography
          variant="h4"
          color="text.secondary"
          fontWeight={300}
          sx={{
            fontSize: {
              xs: "1.675rem",
              sm: "2.125rem",
            },
          }}
        >
          Getting Desired Prompts from{" "}
          <Typography
            component="span"
            variant="inherit"
            color="primary"
            fontWeight="inherit"
          >
            Prompt Library
          </Typography>
        </Typography>

        <Typography
          maxWidth={0.7}
          color="text.primary"
          variant="body1"
          textAlign="center"
          sx={{
            fontSize: {
              sm: "1rem",
              xs: "0.875rem",
            },
          }}
        >
          A centralized “Prompt Library” for creating, managing, and reusing
          your most effective prompts, streamlining your workflow.
        </Typography>
      </Stack>

      <Stack
        width={1}
        marginTop={6}
        direction="row"
        alignItems="center"
        gap={4}
        sx={{
          flexDirection: {
            md: "row",
            xs: "column-reverse",
          },
        }}
      >
        <Box
          width={1}
          border={1}
          borderRadius={4}
          borderColor="text.primary"
          component="img"
          src={desiredPromptsGif}
          alt="desiredPromptsGif"
          sx={{
            objectFit: "contain",
            overflow: "hidden",
          }}
        />

        <Divider
          orientation="vertical"
          flexItem
          sx={{
            borderColor: "text.primary",
            flexDirection: {
              md: "flex",
              xs: "none",
            },
          }}
        />

        <Box
          width={1}
          component="img"
          src={desiredPromptsImage}
          alt="desiredPromptsImage"
          sx={{
            objectFit: "contain",
            overflow: "hidden",
          }}
        />
      </Stack>
    </Stack>
  );
};
